import { executeActions } from "../../server/service";
import { activeContext } from "../../shared/chess";
import type { AppState } from "../../shared/types";

class NeedsEngine extends Error {}
export async function previewActions(
  source: AppState,
  actions: unknown[],
  requestId: string,
) {
  try {
    return (
      await executeActions(
        source,
        actions,
        {
          async analyze() {
            throw new NeedsEngine();
          },
        },
        undefined,
        requestId,
      )
    ).state;
  } catch (error) {
    if (error instanceof NeedsEngine) return null;
    throw error;
  }
}
// Background analysis and clock saves may advance the workspace revision without
// changing a move's meaning. A different board, history or player assignment may not.
export function actionContext(state: AppState, actions: unknown[]) {
  const contextual = actions.some((action) =>
    /^(game\.(makeMove|undo|configure|resign|claimDraw|seek)|position\.|variation\.(create|compare|return)|practice\.(evaluate|hint|next)|calculation\.)/.test(
      (action as { type: string }).type,
    ),
  );
  if (!contextual) return null;
  if (
    actions.some((action) =>
      (action as { type: string }).type.startsWith("practice."),
    )
  )
    return JSON.stringify([
      state.practice?.exerciseIds,
      state.practice?.index,
      state.practice?.solved,
    ]);
  const { game, variation, record } = activeContext(state);
  return JSON.stringify([
    game?.id,
    variation?.id,
    record?.moves,
    state.viewPly,
    game?.mode,
    game?.humanColor,
    game?.result,
  ]);
}
